import { LazyLoad } from '../components/LazyLoad';

export class StringLazyLoad extends LazyLoad<string> {}
